import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import LuggageIcon from "../../../assets/img/luggage.svg";
import { blueLight } from "../../../constants/colors";

const useStyles = makeStyles({
  luggageBadgeStyles: {
    color: blueLight,
  },
});

const LuggageBadge = ({ count, weight }) => {
  const { luggageBadgeStyles } = useStyles();
  return (
    <Box className={luggageBadgeStyles} display="flex" alignItems="center">
      <Typography>
        Baggage: <b>{count}pcs</b>
      </Typography>
      <Box ml={0.5}>
        {Array.from(Array(count).keys()).map((item) => (
          <img src={LuggageIcon} alt="luggage" key={item} />
        ))}
      </Box>{!!weight && (
        <>
          &nbsp;x {weight}lbs
        </>
      )}
    </Box>
  );
};

export default LuggageBadge;
